export default __webpack_public_path__ + "static/media/search-white.dd838c2f.svg";